import React from 'react';
import idx from 'idx';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { getClientLabel } from 'focus_groups/utils';
import { STAGE_DONE, STAGE_VOTE } from 'focus_groups/ducks/vote';
import HeaderTitle from 'header/components/title';

export function mapStateToProps(state) {
  const group = idx(state, _ => _.project.focusGroups.viewState.currentGroup);
  const project = idx(group, _ => _.project);
  const revisions = idx(group, _ => _.revisions);
  const revisionCount = (revisions || []).length;
  const subcategoryName = idx(project, _ => _.sub_category.name) || '';
  const clientLabel = getClientLabel(idx(project, _ => _.client));
  const stage = idx(state, _ => _.project.focusGroups.vote.stage);

  let title, subTitle;

  if (idx(group, _ => _.status) === 'closed') {
    title = 'This focus group has closed.';
  } else if (stage === STAGE_VOTE) {
    title = `Can you help with my ${subcategoryName} project?`;
    subTitle = <span>
      { clientLabel } would love your opinions about the { revisionCount }<br/>
      designs you see below. Make your vote count!
    </span>;
  } else if (stage === STAGE_DONE) {
    title = `Thanks for helping ${clientLabel}!`;
  }

  return {
    title,
    subTitle
  };
}

export default withRouter(connect(mapStateToProps)(HeaderTitle));



// WEBPACK FOOTER //
// ./focus_groups/containers/header_title.js